import { InjectionToken } from "@angular/core";
import { Observable } from "rxjs";

export type LiveChatMessageRole = "user" | "assistant" | "system";

export type AIAgentRunSettleReason = "finished" | "aborted" | "timeout";

export interface LiveChatAdapter
{
    readonly isLive: boolean;

    readonly onUserTypedMessage: Observable<string>;

    readonly onUserTyping: Observable<void>;

    readonly onLiveModeChanged: Observable<boolean>;

    show(): void;

    whenAIAgentRunSettles(timeoutMs?: number): Promise<AIAgentRunSettleReason>;

    enterLiveMode(onEndChat: () => void): void;

    leaveLiveMode(): void;

    appendMessage(role: LiveChatMessageRole, content: string): void;

    appendClientOnlyMessage(role: LiveChatMessageRole, content: string, replaceKey?: string): void;

    upsertClientOnlyMessage(key: string, role: LiveChatMessageRole, content: string): void;

    removeClientOnlyMessage(key: string): void;
}

export const LIVE_CHAT_ADAPTER = new InjectionToken<LiveChatAdapter>("LiveChatAdapter");
